// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__skdZH","cover":"Video_cover__hLu9Z"};
module.exports.__checksum = "dcb66e910fe4"
